import { z } from 'zod';

export const IncomingEmailScalarFieldEnumSchema = z.enum(['incomingemailId','whenReceived','message','site','processed','error']);

export default IncomingEmailScalarFieldEnumSchema;
